import { Alert, Box, Typography } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";

import VoiceAgentSignup from "./voice-agent-signup";
import SchedulerSignup from "./scheduler-signup";

// Map feature_focus URL params to the React component that renders that
// product's signup form. Add an entry per new product.
const SIGNUP_REGISTRY = {
  "voice-agent": VoiceAgentSignup,
  scheduler: SchedulerSignup,
};

const DEFAULT_FEATURE_FOCUS = "voice-agent";

export default function SignupWizard() {
  const [searchParams] = useSearchParams();
  const featureFocus = searchParams.get("feature_focus") || DEFAULT_FEATURE_FOCUS;

  const Component = SIGNUP_REGISTRY[featureFocus];

  if (!Component) {
    return (
      <Box sx={{ maxWidth: 600, mx: "auto", p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Sign up
        </Typography>
        <Alert severity="warning">
          We don't have a signup form for "{featureFocus}".
        </Alert>
      </Box>
    );
  }

  return <Component />;
}
